import React, { useState, useEffect, useContext } from "react";
import { Container, Navbar, Row, Col } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { Link, useNavigate, useLocation } from "react-router-dom";
import eNamadImage from "../../../assets/images/enamad.jpg";
import NavbarLinkItem from "./NavbarLinkItem";
import ContextApp from "./../../../core/contexts/context.app";
//import ApiAuth from "../../../core/api/api.auth";
import ServiceStorage from "../../../core/services/service.storage";
import SplitNumber from "../../components/SplitNumber";
import _ from "lodash";
import {
  IconBasket,
  IconCall,
  IconCategory,
  IconHome,
  IconUser,
  IconClipBoard,
  IconUserCheck,
} from "../../../assets/icons";

function FooterNav() {
  const location = useLocation();
  
  const ctx = useContext(ContextApp);
  //
  const [isLogin, setIsLogin] = useState(ctx.isAuth);
  const [collapsed, setCollapsed] = useState(true);
  const [countBasketItem, setCountBasketItem] = useState(0);
  //const [show, setShow] = useState(false);
  // const handleShow = () => setShow(true);
  // const handleClose = () => setShow(false);
  // 
  const navigate = useNavigate();

  // if (collapsed === false) document.body.classList.add("hiddenOverflow");
  // else document.body.classList.remove("hiddenOverflow");

  useEffect(() => {
    
    if (
      !_.isEmpty(ctx.basketInfo) &&
      !_.isEmpty(ctx.basketInfo.basketItemTemps) &&
      ctx.basketInfo.basketItemTemps.length > 0
    )
      setCountBasketItem(
        ctx.basketInfo.basketItemTemps.filter((e) => e.isDeleted === false)
          .length
      );
    else setCountBasketItem(0);
    setIsLogin(ctx.isAuth);
  }, [ctx.basketInfo, ctx.isAuth]);

  // function signOut() {
  //   //
  //   const result = ApiAuth.logout({
  //     refreshToken: ServiceStorage.getRefreshToken(),
  //   });

  //   ctx.setIsAuth(false);
  //   setCollapsed(true);
  //   navigate("");
  // }

  // function toggleNavbar() {
  //   setCollapsed(!collapsed);
  // }

  function callBack() {
    if (ctx.isAuth) {
      navigate("/profile");
    } else {
      //handleShow();
    }
  }

  function closeNavbar() {
    setCollapsed(true);
  }

  return (
    <>
      <footer>
        {/* ***** mobile ******************************************* */}
        {isMobile ? (
          <>
            {/* {countBasketItem > 0 &&
              location.pathname !== "/payment" &&
              !location.pathname.includes("/order") &&
              !location.pathname.includes("/transaction") &&
              !location.pathname.includes("/wallet") &&
              !location.pathname.includes("/withdrow") && (
                <div
                  className="d-flex justify-content-between align-items-center text-white w-100 bg-danger px-3 py-2 position-fixed "
                  style={{
                    bottom: "56px",
                    zIndex: "1049",
                    borderTop: "1px solid #939393",
                  }}
                >
                  <div className="fs-075 fw-normal">
                    <div>
                      <span className=" fs-09">{countBasketItem}</span> سفارش
                    </div>
                    <div className="fw-bold fs-101">
                      <SplitNumber number={ctx?.basketInfo?.price} /> تومان
                    </div>
                  </div>
                  <div>
                    <Link
                      className="btn btn-light text-white fs-09"
                      to="/payment"
                    >
                      ادامه فرآیند خرید{" "}
                    </Link>
                  </div>
                </div>
              )} */}
            <Navbar
              expanded={!collapsed}
              variant=""
              expand={false}
              className="fixed-bottom border-0 px-1 bg-white"
              id="bottom-nav"
            >
              <div className="d-flex justify-content-between w-100 px-0 menu-bottom-icon">
                <span className="circle-bottom-nav"></span>
                <div>
                  <NavbarLinkItem
                    closeCollapse={closeNavbar}
                    navbarItemHref="/"
                    exactLink="true"
                    styleNameClass=""
                    navbarItemIcon={<IconHome fillColor="#000" />}
                    navbarItemTitle="صفحه اصلی"
                  />
                </div>
                <div>
                  <NavbarLinkItem
                    closeCollapse={closeNavbar}
                    navbarItemHref={
                      ctx.selectedCity?.englishName === undefined
                        ? "/c"
                        : `/c/${ctx.selectedCity?.englishName}`
                    }
                    exactLink="false"
                    styleNameClass=""
                    navbarItemIcon={<IconCategory fillColor="#000" />}
                    navbarItemTitle="دسته بندی"
                  />
                </div>
                <div>
                  <NavbarLinkItem
                    closeCollapse={closeNavbar}
                    navbarItemHref="/basket"
                    exactLink="true"
                    navbarItemIcon={<IconBasket fillColor="#fff" />}
                    navbarItemTitle=""
                    navbarbasketCount={countBasketItem}
                    navbarBadgeDisplay={true}
                    styleNameClass="basket mx-auto "
                  />
                </div>
                <div>
                  {isLogin ? (
                    <NavbarLinkItem
                      exactLink="true"
                      closeCollapse={closeNavbar}
                      navbarItemHref="/order"
                      styleNameClass=""
                      navbarItemIcon={<IconClipBoard fillColor="#000" />}
                      navbarItemTitle="سفارشهای من"
                    />
                  ) : (
                    <NavbarLinkItem
                      exactLink="true"
                      closeCollapse={closeNavbar}
                      navbarItemHref="/contact"
                      styleNameClass=""
                      navbarItemIcon={<IconCall fillColor="#000" />}
                      navbarItemTitle="تماس با ما"
                    />
                  )}
                </div>
                <div>
                  {" "}
                  <NavbarLinkItem
                    exactLink="true"
                    closeCollapse={callBack}
                    navbarItemHref={isLogin ? "/profile" : "/login"}
                    styleNameClass=""
                    navbarItemIcon={
                      isLogin ? (
                        <IconUserCheck fillColor="#000" />
                      ) : (
                        <IconUser fillColor="#000" />
                      )
                    }
                    navbarItemTitle={
                      !isLogin ? "ورود | ثبت نام" : "حساب کاربری"
                    }
                  />
                </div>
              </div>

              {/* {!collapsed ? (
              <></>
            ) : (
              <div className="fixed-top bg-white" style={{ height: "89%" }}>
                <AdvancedMenuItems
                  header={true}
                  advancedMenuTitle="منوی پیشرفته"
                  setCollapsed={setCollapsed}
                  advancedMenuLogo={<IconCategory size={18} />}
                />
                <AdvancedMenuItems
                  advancedMenuTitle="آب و هوای کیش"
                  setCollapsed={setCollapsed}
                  path="/weather"
                  advancedMenuLogo={<IconCategory size={18} />}
                />
                <AdvancedMenuItems
                  advancedMenuTitle="تماس باما"
                  setCollapsed={setCollapsed}
                  path="/contact"
                  advancedMenuLogo={<IconCategory size={18} />}
                />
                {isLogin && (
                  <div>
                    <AdvancedMenuItems
                      setCollapsed={setCollapsed}
                      path="/profile"
                      advancedMenuLogo={<IconCategory size={18} />}
                      advancedMenuTitle="پروفایل"
                    />
                    <AdvancedMenuItems
                      setCollapsed={setCollapsed}
                      path="/order"
                      advancedMenuLogo={<IconCategory size={18} />}
                      advancedMenuTitle="سفارش ها"
                    />{" "}
                    <AdvancedMenuItems
                      setCollapsed={setCollapsed}
                      path="/wallet"
                      advancedMenuLogo={<IconCategory size={18} />}
                      advancedMenuTitle=" کیف پول"
                    />
                  </div>
                )}
              </div>
            )} */}
            </Navbar>
          </>
        ) : (
          // ***** desktop *******************************************
          <>
            {/* <Container
              fluid
              className="bg-light-blue pt-5 text-gray-6 footer py-4"
            >
              <Container className="">
                مجموعه تفریحان مجموعه‌ای جوان و خلاق است که اقدام به ایجاد
                سامانه بومی برای رزرو تفریحات جزیره کیش با قیمت مناسب کرده است
                که شما می‌توانید در این سامانه علاوه بر مشاهده قیمت بروز هر
                تفریح، قوانین و اطلاعات هر تفریح، مشاهده عکس و کلیپ هر تفریح و
                وضعیت جوی جزیره کیش در هر زمان مشاهده نمایید. همچنین یکی دیگر از
                اهداف این مجموعه جلوگیری از سوءاستفاده‌های انجام شده توسط
                کلاهبرداران از مسافران جزیره کیش است که در این راستا اقدامات
                مؤثری انجام داده‌ایم. ما در مجموعه تفریحان در تلاش هستیم تا
                همواره بکوشیم که بهترین و سریع‌ترین خدمات را در هر ساعت از
                شبانه‌روز ارائه نماییم. رضایت مسافر از خدمات و همچنین جلوگیری از
                ایجاد مشکلات متعدد در زمان رزرو اولویت تفریحان می‌باشد و در این
                راه می‌کوشیم تا بهترین خود باشیم.
              </Container> 
            </Container>*/}
            <Container fluid className="bg-light-2 py-4">
              <Container>
                <Row>
                  <Col className="text-start pe-md-0">
                    <a
                      href="tel:07644100000"
                      className="fw-bold text-gray-6 pe-1 d-inline-block"
                    >
                      076-44100000
                    </a>
                    دفتر جزیره کیش
                  </Col>
                  <Col className="text-center px-md-0">
                    <a
                      href="tel:09193373894"
                      className="fw-bold text-gray-6 pe-1 d-inline-block"
                    >
                      09193373894
                    </a>
                    پشتیبانی
                    <span className="d-none d-lg-inline-block">
                      (9:00 الی 23:00)
                    </span>
                  </Col>
                  <Col className="text-end ps-md-0">
                    <a
                      href="tel:09199781891"
                      className="fw-bold text-gray-6 pe-1 d-inline-block"
                    >
                      09199781891
                    </a>
                    پشتیبانی
                    <span className="d-none d-lg-inline-block">
                      (9:00 الی 23:00)
                    </span>
                  </Col>
                </Row>
              </Container>
            </Container>
            <Container fluid className="bg-light-blue text-gray-6 footer py-4">
              <Container className="footer">
                <Row>
                  <Col xl="8">
                    <div className="d-flex">
                      <Link className="me-3 " to="/">
                        صفحه اصلی
                      </Link>
                      <Link
                        className="me-3 "
                        to={
                          ctx.selectedCity?.englishName === undefined
                            ? "/c"
                            : `/c/${ctx.selectedCity?.englishName}`
                        }
                      >
                        دسته بندی
                      </Link>
                      <Link className="me-3 " to="/contact">
                        ارتباط با ما
                      </Link>
                      <Link className="me-3 " to="/weather">
                        آب و هوای کیش
                      </Link>
                      <Link className="me-3 " to="/s/kishportinfo">
                        اطلاعات حرکت شناورها از بندر چارک
                      </Link>
                    </div>
                    <div className="mt-3">
                      آدرس : جزیره کیش - بلوار میر مهنا - روبروی بازار پارس خلیج
                      - مرکز نوآوری کیش - طبقه 4 - واحد 401 - شرکت رایان سفر
                      نیکان کیش
                    </div>
                    <div className="fs-075 mt-2">
                      Copyright ©2024 - Tafrihan.com
                    </div>
                  </Col>
                  <Col className="text-end">
                    <div>
                      {/* <a
                        referrerPolicy="origin"
                        rel="noreferrer"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
                      >
                        <img
                          referrerPolicy="origin"
                          className="rounded-3 h-100 "
                          src={eNamadImage}
                          alt="eNamad"
                          style={{ cursor: "pointer" }}
                          id="A32132KLXam6f2jcPJyV"
                        />
                      </a> */}
                      <a
                    referrerPolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
                  >
                    <img
                    alt="eNamad"
                      referrerPolicy="origin"
                      className="rounded-3 h-100 "
                      src={eNamadImage}
                      style={{ cursor: "pointer" }}
                      id="A32132KLXam6f2jcPJyV"
                    />
                  </a>
                    </div>

                    {/* <img
                      id="A32132KLXam6f2jcPJyV"
                      style={{
                        cursor: "pointer",
                        width: "6.7em",
                        display: "inline-block",
                      }}
                      referrerpolicy="origin"
                      className="rounded-3 h-100 "
                      onclick='window.open("https://Trustseal.eNamad.ir/logo.aspx?id=274889&amp;Code=A32132KLXam6f2jcPJyV","Popup","toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30")'
                      alt="enamad"
                      src={eNamadImage}
                    ></img> */}
                  </Col>
                </Row>
              </Container>
            </Container>
          </>
        )}
      </footer>
    </>
  );
}
export default FooterNav;

/* <Col xs='12' lg='5' className='d-flex justify-content-center justify-content-lg-end mt-3 mt-lg-0'>
<div className=' ' style={{ width: '90px', height: '90px' }}>
    <a referrerPolicy="origin"
        target="_blank" href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV">
        <img
            referrerPolicy="origin"
            className=' img-fluid  w-100 h-100'

            src="https://Trustseal.eNamad.ir/logo.aspx?id=274889&amp;Code=A32132KLXam6f2jcPJyV" alt="eNamad" style={{ cursor: "pointer" }} id="A32132KLXam6f2jcPJyV" />
    </a>
</div>
</Col> */
